<template>
  <organism-create-edit-config-template
    v-if="!isLoading"
    :tagOptions="tagOptions"
    :configTemplateDetail="configTemplateDetail"
    @createTemplate="createTemplateToApi"
    @updateTemplate="updateTemplateToApi"
    @deleteTemplate="deleteTemplateToApi"
  ></organism-create-edit-config-template>
</template>

<script>
import {
  getTemplateById,
  getTagsList,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from "@/api/api-module4"
import mixins from "@/mixins"
import OrganismCreateEditConfigTemplate from "@/components/organisms/networkConfigurationManagement/configurationTemplate/OrganismCreateEditConfigTemplate.vue"

export default {
  name: "CreateEditConfigTemplate",
  components: {
    OrganismCreateEditConfigTemplate,
  },
  mixins: [mixins],
  data() {
    return {
      method: "create",

      tagOptions: null,

      configTemplateDetail: null,
    }
  },
  computed: {
    isLoading() {
      return !this.tagOptions || !this.configTemplateDetail
    },
    id() {
      return this.$route?.params?.id
    },
  },
  async created() {
    this.method = this.$route.path.includes("create-new-template")
      ? "create"
      : "edit"
    await this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      await Promise.all([
        this.getTagsListFromApi(),
        this.getConfigTemplateDetailFromApi(),
      ])
    },

    async getTagsListFromApi() {
      this.showLoading(true)
      this.tagOptions = []
      await getTagsList()
        .then((tags) => {
          this.tagOptions = tags
        })
        .finally(() => this.showLoading(false))
    },

    async getConfigTemplateDetailFromApi() {
      if (this.method === "edit") {
        this.showLoading(true)
        await getTemplateById(this.id)
          .then((template) => {
            this.configTemplateDetail = {
              id: template.configTemplateId,
              name: template.configTemplateName,
              tags: template.tags,
              description: template.configTemplateDescription,
              config: template.configTemplateScript,
            }
          })
          .finally(() => this.showLoading(false))
      } else {
        this.configTemplateDetail = {
          name: null,
          tags: [],
          description: null,
          config: null,
        }
      }
    },

    async createTemplateToApi(request) {
      this.showLoading(true)
      await createTemplate(request)
        .then((response) => {
          if (response.status === "ok") {
            this.toastSuccess("Template created successfully")
            this.navigateTo(
              `/network-configuration/configuration-template/${response.data.configTemplateId}`
            )
          } else {
            this.toastError("Template created failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateTemplateToApi(request) {
      this.showLoading(true)
      await updateTemplate(this.id, request)
        .then((response) => {
          if (response.status === "ok") {
            this.toastSuccess("Template updated successfully")

            this.getConfigTemplateDetailFromApi()
          } else {
            this.toastError("Template updated failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    async deleteTemplateToApi(id) {
      this.showLoading(true)
      await deleteTemplate(id)
        .then(async (response) => {
          if (response.status === "ok") {
            this.toastSuccess("Template deleted successfully")
            this.navigateTo("/network-configuration/configuration-template")
          } else {
            this.toastError("Template deleted failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
